import { useDebouncedCallback } from 'use-debounce'
import SearchBar from "./SearchBar"
import { IoFilterSharp } from "react-icons/io5"

export default function AmSearchBar({ handleSearch, handleReset, onOpen, showFilterIcon, dataFetching, searchBarValue, setSearchBarValue }) {
  const debouncedSearch = useDebouncedCallback(
    (value) => {
      handleSearch(value)
    },
    500
  )

  const handleChange = (value) => {
    setSearchBarValue(value)
    debouncedSearch(value)
  }

  return(
    <div className="flex w-full items-center bg-grey-900 text-left text-md text-grey-300 hover:cursor-pointer">
      <div className="flex w-full items-center">
        <SearchBar
          onChange={handleChange}
          value={searchBarValue}
          setSearchTerm={setSearchBarValue}
          handleReset={handleReset}
          showSpinner={dataFetching}
        />
        {showFilterIcon &&
          <IoFilterSharp
            data-testid="filter-button"
            onClick={onOpen}
            style={{ cursor: "pointer", marginLeft: "10px" }}
            className="text-2xl text-grey-300"
          />
        }
      </div>
    </div>
  )
}